<template>
  <div id="content"
       class="container">
    <header class="m15">
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('onlineTraining')">首页</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('trainTrend')">工业动态</div>
      </div>
    </header>
    <div class="all-left-wrap">
      <div class="question-classify">
        <ul style="margin-top:0px">
          <li v-for="(data,index) in dataTitle"
              :class="currentIndex===index?'checked':''"
              :key="index"
              @click="handleIndex(index)">{{data}}</li>
        </ul>
      </div>
      <div class="train-cont"
           v-if="currentIndex === 0 || currentIndex === 1">
        <ul>
          <li v-for="data in dataList"
              :key="data.id">
            <div class="train-left-img">
              <img :src="data.imageUrl?data.imageUrl:imgUrl" />
            </div>
            <div class="train-right-con">
              <h3 @click="handleDetail(data.id)"
                  style="margin-top:-5px">{{data.title}}</h3>
              <p class="train-p">{{data.summary}}</p>
              <div>
                <div class="train-time">{{data.publishTime}}</div>
                <div class="train-good">
                  <div class="train-comment"
                       @click="handleDetail(data.id)">
                    <img style="float:left;"
                         title="评论"
                         src="@/assets/img/comment_03.png" />
                    <span style="float:left;margin-left:5px;width:40px;">{{data.commentCount}}</span>
                  </div>
                  <div class="train-praise"
                       @click="handleZan(data.id)">
                    <img style="float:left;"
                         title="赞一下"
                         src="@/assets/img/zan_03.png" />
                    <span style="float:left;margin-left:5px;width:40px;">{{data.praiseCount}}</span>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="doclist-pagination"
           v-if="(dataList === [] || dataList.length !== 0) && (currentIndex === 0 || currentIndex === 1)">
        <div class="doclist-lastpage"
             @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':''"
              v-for="(item, index) in pageList"
              :key="index"
              @click="toDataList(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage"
             @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">
          共{{totalPage}}页，到第
          <input type="text"
                 v-model.number="jumpTargetPage" />页
        </div>
        <div class="doclist-jump"
             @click="jumpFarPage">确定</div>
      </div>
      <trainKnowledge ref="trainKnowledge"
                      v-if="currentIndex === 2"
                      :name="currentIndex"></trainKnowledge>
    </div>
    <trainTrendRank ref="trainTrendRank"
                    :name="currentIndex"></trainTrendRank>
  </div>
</template>
<script>
import trainTrendRank from './trainTrendRank'
import trainKnowledge from './trainKnowledge'
export default {
  data () {
    return {
      currentIndex: 0,
      dataTitle: ['新闻', '培训留念', '工业头条'],
      imgUrl: require('@/assets/img/bitmap.png'),
      pageSize: 10,
      totalPage: 0,
      totalData: 0,
      dataList: [],
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1
    }
  },
  components: {
    trainTrendRank,
    trainKnowledge
  },
  watch: {
    '$route.query': {
      handler: 'routerWatchFun'
    }
  },
  mounted () {
    let trainListQuery = sessionStorage.getItem('trainListQuery')
    if (this.$route.query.page && trainListQuery && JSON.parse(trainListQuery)) {
      trainListQuery = JSON.parse(trainListQuery)
      this.currentPage = trainListQuery.page
      this.currentIndex = trainListQuery.currentIndex
      this.changePageTo(trainListQuery.page)
      this.$nextTick(() => {
        if (this.currentIndex === 0) {
          this.$refs.trainTrendRank.getDataList()
        } else if (this.currentIndex === 1) {
          this.$refs.trainTrendRank.getMerDataList()
        } else {
          if (this.$refs.trainKnowledge) {
            this.$refs.trainKnowledge.setSearch(trainListQuery.trainListSearch)
          }
          this.$refs.trainTrendRank.getTopList()
        }
      })
    }
    if (this.currentIndex === 0) {
      this.getDataList()
    } else if (this.currentIndex === 1) {
      this.getMerDataList()
    }
  },
  methods: {
    routerWatchFun () {
      sessionStorage.setItem('trainListQuery', JSON.stringify({
        ...this.$route.query
      }))
      if (this.currentIndex === 0) {
        this.getDataList()
      } else if (this.currentIndex === 1) {
        this.getMerDataList()
      } else {
        this.$nextTick(() => {
          if (this.$refs.trainKnowledge) {
            this.$refs.trainKnowledge.setSearch()
          }
        })
      }
    },
    routerPush (params = {}) {
      let query = {
        page: 1,
        limit: 10,
        currentIndex: this.$route.query.currentIndex,
        ...params
      }
      this.$router.push({
        name: 'trainTrendList',
        query: query
      })
    },
    toDataList (item) {
      this.changePageTo(item)
      this.routerPush({
        page: item
      })
      // if (this.currentIndex === 0) {
      //   this.getDataList(item)
      // } else if (this.currentIndex === 1) {
      //   this.getMerDataList(item)
      // }
    },
    routerHandle (routerName) {
      if (routerName === 'onlineTraining') {
        this.$router.push({ name: 'onlineTraining' })
      } else if (routerName === 'trainTrend') {
        this.$router.push({ name: 'trainTrendList' })
      }
    },
    handleIndex (index) {
      this.currentPage = 1
      this.currentIndex = index
      this.routerPush({
        page: this.currentPage,
        currentIndex: this.currentIndex
      })
      if (index === 0) {
        this.$refs.trainTrendRank.getDataList()
      } else if (index === 1) {
        this.$refs.trainTrendRank.getMerDataList()
      } else {
        this.$refs.trainTrendRank.getTopList()
      }
    },
    // 获取工业头条
    getTopList () {

    },
    // 获取新闻数据列表
    getDataList () {
      let params = {}
      if (this.$route.query.page) {
        params = {
          page: Number(this.$route.query.page),
          limit: Number(this.$route.query.limit)
        }
      } else {
        params = {
          page: 1,
          limit: 10
        }
      }
      this.$http.post(`/front/train/trainNews/searchNewsAtBackGround`,
        params
      ).then(({ data: res }) => {
        if (res.code === 0) {
          this.dataList = res.data.data
          this.totalData = (res && res.data && res.data.count) || 0
          // 分页
          this.totalPage = Math.ceil(res.data.count / 10)
          this.changePageTo(params.page)
        }
      })
      this.jumpTargetPage = 1
    },
    // 获取留念数据
    getMerDataList (page = this.currentPage) {
      this.$http.post(`/front/train/trainNews/searchMemorialAtBackGround`,
        {
          page: page,
          limit: this.pageSize
        }
      ).then(({ data: res }) => {
        if (res.code === 0) {
          this.dataList = res.data.data
          this.totalData = (res && res.data && res.data.count) || 0
          // 分页
          this.totalPage = Math.ceil(res.data.count / 10)
          this.changePageTo(page)
        }
      })
      this.jumpTargetPage = 1
    },
    // 跳转详情
    handleDetail (id) {
      this.$http.post(`/front/train/trainQuestionAnswer/plusViewCount`,
        {
          type: 1, // type --1:新闻/2：课程/3：图书/4：问答
          id: id
        }).then(({ data: res }) => { })
        .catch(() => { })
      this.$router.push(
        { name: 'trainTrendInfo', query: { id: id } }
      )
    },
    // 点赞
    handleZan (id) {
      this.$http.post(`front/train/trainPraise/save`, {
        'targetId': id,
        'type': 3
      }).then(({ data: res }) => {
        if (res.code === 0) {
          this.$message({
            message: '点赞成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              if (this.currentIndex === 0) {
                this.getDataList()
              } else if (this.currentIndex === 1) {
                this.getMerDataList()
              }
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
        this.routerPush({
          page: this.currentPage
        })
        // if (this.currentIndex === 0) {
        //   this.getDataList(newCurrent)

        // } else if (this.currentIndex === 1) {
        //   this.getMerDataList(newCurrent)
        // }
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
        this.routerPush({
          page: this.currentPage
        })
        // if (this.currentIndex === 0) {
        //   this.getDataList(newCurrent)
        // } else if (this.currentIndex === 1) {
        //   this.getMerDataList(newCurrent)
        // }
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (
            this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4
          ) {
            var newPageList3 = []
            for (
              let index = this.jumpTargetPage - 2;
              index < this.jumpTargetPage + 3;
              index++
            ) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [
              this.totalPage - 4,
              this.totalPage - 3,
              this.totalPage - 2,
              this.totalPage - 1,
              this.totalPage
            ]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.changePageTo(this.currentPage)
        this.routerPush({
          page: this.currentPage
        })
        // if (this.currentIndex === 0) {
        //   this.getDataList()
        // } else if (this.currentIndex === 1) {
        //   this.getMerDataList()
        // }
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    }
  }
}
</script>
<style scoped>
li {
  list-style: none;
}
.all-left-wrap {
  width: 870px;
  min-height: 1531px;
  float: left;
  background: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
}
.question-classify {
  background: #fff;
  height: 41px;
  line-height: 41px;
  border-bottom: 1px solid #1d65a8;
}
.question-classify ul {
  width: 100%;
  height: 40px;
}
.question-classify ul li {
  float: left;
  width: 120px;
  color: #333;
  cursor: pointer;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  line-height: 40px;
  height: 40px;
  text-align: center;
}
.question-classify ul li.checked {
  background: #1d65a8;
  color: #fff;
}
.train-cont {
  width: 870px;
  min-height: 400px;
  padding: 0 20px;
}
.train-cont ul li {
  padding: 15px 0;
  height: 140px;
  width: 830px;
  list-style: none;
  border-bottom: 1px solid #ccc;
}
.train-left-img {
  float: left;
  width: 200px;
  height: 110px;
}
.train-left-img img {
  width: 100%;
  height: 110px;
}
.train-right-con {
  float: left;
  width: 630px;
  height: 110px;
  padding-left: 10px;
}
.train-right-con h3 {
  font-weight: 600;
  color: #333;
  cursor: pointer;
  width: 620px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.train-right-con h3:hover {
  color: #1d65a8;
}
.train-p {
  width: 480px;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 10px;
  margin-bottom: 25px;
}
.train-time {
  float: left;
  width: 170px;
  height: 30px;
  line-height: 40px;
  color: #999;
}
.train-good {
  float: right;
  width: 150px;
  height: 30px;
  padding-top: 10px;
  padding-left: 10px;
}
.train-comment {
  width: 65px;
  height: 30px;
  float: left;
  cursor: pointer;
}
.train-comment img {
  width: 15px;
  height: 15px;
}
.train-praise {
  float: left;
  width: 65px;
  height: 30px;
  cursor: pointer;
}
.train-praise img {
  width: 15px;
  height: 15px;
}
</style>
